/* eslint-disable */
// import Cookies from 'js-cookie'

const MemberSessionKey = 'Member-Session'
const XAuthTokenKey = 'Member-Token'
const XAuthAgentKey = 'Agent-Token'
const AgentSessionKey = 'Agent-Session'
// Sesi impersonation memakai key standar Member-Token/Member-Session agar
// kompatibel dengan seluruh mekanisme autentikasi member yang sudah ada
// (navigation guard, request interceptor, dan halaman lama). Sesi sebelumnya
// di-backup agar dapat dipulihkan saat kembali ke ZEUS.
const ImpersonationActiveKey = 'Impersonation-Active'
const ImpersonationBackupTokenKey = 'Impersonation-Backup-Token'
const ImpersonationBackupSessionKey = 'Impersonation-Backup-Session'
// Key lama dari implementasi sebelumnya; dibersihkan agar tidak membingungkan.
const LegacyImpersonationTokenKey = 'Impersonation-Member-Token'
const LegacyImpersonationSessionKey = 'Impersonation-Member-Session'
const AuthorizationUsername = 'tejomurtiproject'
const AuthorizationPassword = 'aF7LDyx!h!wd$LyS:~@k@M9[vR}_wf{-'
const Authorization = 'Basic ' + btoa(AuthorizationUsername + ':' + AuthorizationPassword)
const ShowModalPromo = 'Modal-Promo'
const referralCode = 'Referral-Code'
const ShowModalOnlineDemo = 'Modal-Online-Demo'


export function setShowModalOnlineDemo(value) {
  return localStorage.setItem(ShowModalOnlineDemo, value)
}

export function removeShowModalOnlineDemo() {
  return localStorage.removeItem(ShowModalOnlineDemo)
}

export function getShowModalOnlineDemo() {
  return localStorage.getItem(ShowModalOnlineDemo)
}

export function setReferralCode(value) {
  return localStorage.setItem(referralCode, value)
}
export function removeReferralCode() {
  return localStorage.removeItem(referralCode)
}

export function getReferralCode() {
  return localStorage.getItem(referralCode)
}

export function setShowModalPromo(value) {
  return localStorage.setItem(ShowModalPromo, value)
}

export function removeShowModalPromo() {
  return localStorage.removeItem(ShowModalPromo)
}

export function getShowModalPromo() {
  return localStorage.getItem(ShowModalPromo)
}

export function getMemberSession() {
  return localStorage.getItem(MemberSessionKey)
}
export function setMemberSession(data) {
  return localStorage.setItem(MemberSessionKey, JSON.stringify(data))
}

export function removeMemberSession() {
  return localStorage.removeItem(MemberSessionKey)
}

// Menandai bahwa sesi aktif berasal dari impersonation ZEUS.
export function isImpersonating() {
  return localStorage.getItem(ImpersonationActiveKey) === '1'
}

// Memulai sesi impersonation:
//  1. backup sesi yang sedang aktif (bisa sesi member normal, atau token admin
//     ZEUS bila kedua aplikasi berada di origin yang sama);
//  2. simpan token impersonation pada key standar Member-Token agar terbaca
//     oleh navigation guard/request interceptor existing;
//  3. hapus Member-Session lama agar profil dimuat ulang dari token baru.
export function beginImpersonationSession(token) {
  const alreadyImpersonating = isImpersonating()

  // Jangan menimpa backup asli jika impersonation dimulai ulang tanpa
  // diakhiri; backup pertama adalah sesi sebelum impersonation.
  if (!alreadyImpersonating) {
    const previousToken = localStorage.getItem(XAuthTokenKey)
    const previousSession = localStorage.getItem(MemberSessionKey)

    if (previousToken !== null && previousToken !== '') {
      localStorage.setItem(ImpersonationBackupTokenKey, previousToken)
    } else {
      localStorage.removeItem(ImpersonationBackupTokenKey)
    }

    if (previousSession !== null) {
      localStorage.setItem(ImpersonationBackupSessionKey, previousSession)
    } else {
      localStorage.removeItem(ImpersonationBackupSessionKey)
    }

    localStorage.removeItem(LegacyImpersonationTokenKey)
    localStorage.removeItem(LegacyImpersonationSessionKey)
  }

  localStorage.setItem(ImpersonationActiveKey, '1')
  localStorage.setItem(XAuthTokenKey, token)
  localStorage.removeItem(MemberSessionKey)
}

// Mengakhiri impersonation dan memulihkan sesi sebelumnya (jika ada).
// Dipakai saat tombol "Kembali ke ZEUS" berhasil.
export function endImpersonationSession() {
  const backupToken = localStorage.getItem(ImpersonationBackupTokenKey)
  const backupSession = localStorage.getItem(ImpersonationBackupSessionKey)

  localStorage.removeItem(XAuthTokenKey)
  localStorage.removeItem(MemberSessionKey)

  if (backupToken !== null && backupToken !== '') {
    localStorage.setItem(XAuthTokenKey, backupToken)
    if (backupSession !== null) {
      localStorage.setItem(MemberSessionKey, backupSession)
    }
  }

  discardImpersonationSession()
}

// Membuang sesi impersonation tanpa memulihkan backup. Dipakai saat login
// normal baru atau saat token impersonation dinyatakan tidak valid (401).
export function discardImpersonationSession() {
  localStorage.removeItem(ImpersonationBackupTokenKey)
  localStorage.removeItem(ImpersonationBackupSessionKey)
  localStorage.removeItem(ImpersonationActiveKey)
  localStorage.removeItem(LegacyImpersonationTokenKey)
  localStorage.removeItem(LegacyImpersonationSessionKey)
}

export function getAuthBasic() {
  return Authorization;
}
export function getXAuthToken() {
  return localStorage.getItem(XAuthTokenKey)
}
export function setXAuthToken(token) {
  return localStorage.setItem(XAuthTokenKey, token)
}

export function removeXAuthToken() {
  return localStorage.removeItem(XAuthTokenKey)
}

export function getXAuthAgent() {
  return localStorage.getItem(XAuthAgentKey)
}
export function setXAuthAgent(token) {
  return localStorage.setItem(XAuthAgentKey, token)
}

export function removeXAuthAgent() {
  return localStorage.removeItem(XAuthAgentKey)
}


export function getAgentSession() {
  return localStorage.getItem(AgentSessionKey)
}
export function setAgentSession(data) {
  return localStorage.setItem(AgentSessionKey, JSON.stringify(data))
}

export function removeAgentSession() {
  return localStorage.removeItem(AgentSessionKey)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js